import styled, { css } from 'styled-components/macro';

interface OverlayProps {
  show: boolean;
}

export default styled.div<OverlayProps>`
  position: absolute;
  z-index: 1;
  height: 0;

  ${(props) =>
    props.show &&
    css`
      backdrop-filter: brightness(40%);
      width: 100vw;
      height: 100vh;
    `}
`;
